export const css = {
    root: '_2tBRHHj9',
    scoreContainer: '_3Ee5V6Jg',
    title: '_2OxdRqO9',
    wrapper: 'daJTJmWY',
    domain: 'T2kMMuOV',
    field: '_3PyWb3IB',
    bar: '_3sTaDA0r',
    lowScore: '_3wEE_bix',
    midScore: '_2iUIcR0x',
    highScore: '-cOu-Whj',
    barZero: '_127N8rVw',
    barLow: '_1KNb94Qg',
    barMid: '_3MF6IDA_',
    barHigh: '_3wdnmJSF',
    barscore: '_2iJBcQU6',
    legend: '_1fy1De5y',
    ' _key': 'prepost-viz/progress-viz'
};
export default css;
